// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"index_logoContainer_2JZMd","block":"index_block_1ngbq","inner":"index_inner_24YeA","form":"index_form_3Yj8U"};